import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FormGroup, Input, Label, Table } from "reactstrap";
import { v4 as uuidv4 } from 'uuid'

import { confirm } from "components/Confirmation";
import IconButton from "components/IconButton";

import cruzamentoService from "services/CruzamentoService";
import componenteService from "services/ComponenteService";
import { useNavigate } from "react-router-dom";
import AppContext from "AppContext";
import { estadoComponenteText } from "services/ComponenteService";

export default function Componentes({ cruzamento }) {
  const [items, setItems] = useState([])
  const navigate = useNavigate()
  const { state } = useContext(AppContext)

  const carregar = async () => {
    if (!cruzamento)
      return
    const res = await componenteService.getByCruzamento(cruzamento.id)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    if (cruzamento && cruzamento.id) {
      carregar()
    }
  }, [cruzamento])

  const handleAdicionar = async (data) => {
    // try {
    //   const res = await empresaService.createResponsavelTecnico(idEmpresa, data)
    //   if (res.success) {
    //     carregar()
    //     toast("Responsável técnico cadastrado")
    //   } else {
    //     toast("Erro ao cadastrar responsável técnico")
    //   }
    // } catch (ex) {
    //   toast("Erro ao cadastrar responsável técnico")
    // }
  }

  return (
    <>
      <div className="row">
        <FormGroup className={`col-3`}>
          <Label>Cruzamento</Label>
          <Input type="text" value={cruzamento?.numero || ''} disabled />
        </FormGroup>
      </div>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Nome</th>
            <th scope="col">Tipo</th>
            <th scope="col">Modelo</th>
            <th scope="col">Estado de Conservação</th>
            <th scope="col">Instalado em</th>
            <th scope="col">Prazo de Garantia</th>
            <th scope="col" style={{ width: 60 }}></th>
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={7} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.filter(el => !el.idComponentePai).map(el => (
            <React.Fragment key={el.id}>
              <tr>
                <td>{el.qrCode}</td>
                <td>{el.tipoComponente}</td>
                <td>{el.modelo}</td>
                <td>{estadoComponenteText(el.estado)}</td>
                <td>{el.desde}</td>
                <td>{el.garantiaAte}</td>
                <td className="d-flex flex-row gap-5px">
                  <IconButton
                    alt="Editar"
                    iconClass="bi-pencil-square"
                    onClick={() =>
                      navigate(`/admin/componentes/${el.id}?returnUrl=/admin/cruzamentos/${cruzamento.id}&aba=componentes`)}
                  />
                </td>
              </tr>
              {items.filter(c => c.idComponentePai === el.id).map(sub => (
                <tr key={sub.id}>
                  <td><i className="bi bi-arrow-return-right ml-2"></i> {sub.qrCode}</td>
                  <td>{sub.tipoComponente}</td>
                  <td>{sub.modelo}</td>
                  <td>{estadoComponenteText(sub.estado)}</td>
                  <td>{sub.desde}</td>
                  <td>{sub.garantiaAte}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton
                      alt="Editar"
                      iconClass="bi-pencil-square"
                      onClick={() =>
                        navigate(`/admin/componentes/${sub.id}?returnUrl=/admin/cruzamentos/${cruzamento.id}&aba=componentes`)}
                    />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </>
  )
}